import { Component, OnInit, inject, computed } from '@angular/core'
import { filter, first, forkJoin, of, switchMap } from 'rxjs'

import { SessionService } from '@hunt/services'

import { AuthService } from '../../auth/auth.service'
import {
  TrackingEventEnum,
  TrackingService,
} from '../../tracking/tracking.service'
import { HuntTemplateService } from '../shared/services/hunt-template.service'

import { HuntAPIService } from './services/api/hunt-api.service'

@Component({
  standalone: false,
  templateUrl: './hunt.component.html',
  styleUrls: ['./hunt.component.scss'],
})
export class HuntManagementComponent implements OnInit {
  private readonly authService = inject(AuthService)
  private readonly trackingService = inject(TrackingService)
  private readonly huntService = inject(HuntAPIService)
  private readonly huntTemplateService = inject(HuntTemplateService)
  private readonly sessionService = inject(SessionService)

  public ngOnInit(): void {
    // Initialize session service to load the hunt if available
    if (this.sessionService.activeHunt()?.id) {
      this.sessionService.loadHunt(this.sessionService.activeHunt()?.id)
    }
    this.authService.user$
      .pipe(
        filter((user) => !!user),
        first(),
        switchMap((user) => {
          return forkJoin({
            user: of(user),
            totalHunts: this.huntService.getTotalHunts(),
            completedHunts: this.huntService.getCompletedHunts(),
            totalHuntTemplates:
              this.huntTemplateService.getTotalHuntTemplates(),
          })
        }),
      )
      .subscribe((result) => {
        this.trackingService.trackEvent(TrackingEventEnum.HUNT_METADATA, {
          total_hunts: result.totalHunts.result,
          completed_hunts: result.completedHunts.result,
          total_hunt_templates: result.totalHuntTemplates.result,
        })
      })
  }
}
